import { createFileRoute } from '@tanstack/react-router'
import { Termos } from '@/features/termos/Termos'

/** Termos com versão. Publicar pede aceite novo de cada paciente. */
export const Route = createFileRoute('/_app/app/config/termos')({ component: Termos })
